import { IconProps } from "./Icon.model";

export function Notifications01({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.9396 7.63444C3.08126 4.94302 5.30485 2.83337 8 2.83337C10.6951 2.83337 12.9187 4.94302 13.0604 7.63444C13.0665 7.74946 13.071 7.8596 13.0753 7.96571V7.96572C13.0901 8.32673 13.1029 8.64104 13.1683 8.94221C13.2465 9.30212 13.3911 9.58506 13.6852 9.80564C14.1981 10.1903 14.5 10.794 14.5 11.4352C14.5 12.356 13.7752 13.1667 12.8 13.1667H3.2C2.22479 13.1667 1.5 12.356 1.5 11.4352C1.5 10.794 1.80185 10.1903 2.31475 9.80564C2.60886 9.58506 2.7535 9.30212 2.83166 8.94221C2.89707 8.64103 2.90993 8.32672 2.9247 7.96571L2.9247 7.96569C2.92904 7.85959 2.93355 7.74946 2.9396 7.63444Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.01904 0.916184C7.31578 0.72193 7.67799 0.666626 8 0.666626C8.32201 0.666626 8.68422 0.72193 8.98096 0.916184C9.31016 1.13169 9.5 1.48051 9.5 1.91663C9.5 2.31407 9.34467 2.72913 9.1084 3.04701C8.87584 3.35988 8.49434 3.66663 8 3.66663C7.50566 3.66663 7.12416 3.35988 6.8916 3.04701C6.65533 2.72913 6.5 2.31407 6.5 1.91663C6.5 1.48051 6.68984 1.13169 7.01904 0.916184Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00004 12C6.36823 12 6.66671 12.2985 6.66671 12.6667C6.66671 13.403 7.26366 14 8.00004 14C8.73642 14 9.33337 13.403 9.33337 12.6667C9.33337 12.2985 9.63185 12 10 12C10.3682 12 10.6667 12.2985 10.6667 12.6667C10.6667 14.1394 9.4728 15.3333 8.00004 15.3333C6.52728 15.3333 5.33337 14.1394 5.33337 12.6667C5.33337 12.2985 5.63185 12 6.00004 12Z"
        fill={fillColor}
      />
    </svg>
  );
}

